// extracted by mini-css-extract-plugin
export default {"pagination":"vrL0X4jLDjrq5wSI1hal","pageItem":"tpSzqHnLxWAQlC79ZfNc","currentPage":"bNg_PBi0bk4MZyioEHV3","pageLink":"meru1RM2lIMPphKZeqSb"};